import { withAppConfig } from '../../../../../appConfigContext';
import { inject } from 'mobx-react';
import { compose } from 'recompose';
import appConstants from '../../../../../appConstants';
import { EXCEPTION_FLOW } from '../DriverPopUp/common/constants';
import { getExceptionNumberLabel, parseExceptionConfig } from '../DriverPopUp/EditStopDialog/ProcessDelivery/ExceptionDetails/utils';
import Detail from './common/Detail';

const ExceptionAndReturnDetails = ({ detail, type, configJSON, DispatchStore }) => {
  const exceptionNumberLabel = getExceptionNumberLabel(DispatchStore);
  const exceptionConfig = parseExceptionConfig(configJSON?.exceptionConfig);
  const exceptionFlow = exceptionConfig?.exceptionFlow;
  if (exceptionFlow === EXCEPTION_FLOW.ADE) {
    return (
      <>
        {type === appConstants.DELIVERY_CODE.RTN && (
          <Detail label="Customer Name" value={detail?.customerName} />
        )}
        <Detail label={exceptionNumberLabel} value={detail?.adeNumber} />
      </>
    );
  }
  return (
    <>
      <Detail label="Exception Pcs" value={detail?.pieces} />
      <Detail label="Pkg Type" value={detail?.packageType} />
      <Detail label="Description" value={detail?.description} isFullWidth/>
    </>
  );
};

export default compose(
  inject('DispatchStore'),
  withAppConfig
)(ExceptionAndReturnDetails);
